import {
    Component,
    OnDestroy,
    OnInit,
    SimpleChanges,
    ElementRef,
} from "@angular/core";
import { SubSink } from "subsink";
import { SharedDataService } from "../../../shared/sharedData.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { NbcLoggerService } from "../../../shared/logger/nbc-logger.service";
import { empty, Observable, Subject, Subscriber } from "rxjs";
import { switchMap, takeUntil } from "rxjs/operators";
import {
    EmitEvent,
    EventBusService,
} from "../../../core/services/event-bus.service";
import * as _ from "lodash";
import { TemplateService } from "../../../shared/services/template.service";
import { NbcBudgetCodeComponent } from "../../../shared/component/nbc-budget-code/nbc-budget-code.component";
import { LookUpService } from "../../../shared/services/lookup.service";

@Component({
    selector: "template-details-grid",
    templateUrl: "./template-details-grid.component.html",
    standalone: false
})
export class TemplateDetailsGridComponent implements OnInit, OnDestroy {
    constructor(
        private _eventBusService: EventBusService,
        private _modalService: BsModalService,
        private templateService: TemplateService,
        private _sharedDataService: SharedDataService,
        private _eventBus: EventBusService,
        private _lookupService: LookUpService,
        private log: NbcLoggerService
    ) {}

    bsModalRef?: BsModalRef;
    sub = new SubSink();
    buAccess: any;
    templates: any;
    templateslength: any;
    queryContainer: any;
    sports: any = [];
    broadcastNetworks: any = [];
    employeeTypes: any = [];
    dayTypes: any = [];
    workStates: any = [];
    companyCodes: any = [];
    showwbse = true;
    showcc = false;
    disableClearButton = false;
    costCenterType: any;
    contactNameObservable$: Observable<any[]> | undefined;
    componentDestroyed$: Subject<boolean> = new Subject();
    searchObj = {
        templateName: "",
    };
    modifiedListItems: any = [];
    WBSEModal: any = false;

    onContactNameValueSelected($event) {
        const contact = $event.item;
        this.templates.contact = contact.fullName;
    }

    // Autocomplete of Contact Name
    searchContactName() {
        this.contactNameObservable$ = new Observable(
            (observer: Subscriber<string>) => {
                // Runs on every search
                observer.next(this.templates.contact);
            }
        ).pipe(
            takeUntil(this.componentDestroyed$),
            switchMap((token: string) => {
                return this._lookupService.searchbynameHcmData(
                    encodeURIComponent(token)
                );
            })
        );
    }

    sortColumn($event, column) {
        if (this.queryContainer.query.sortByColumn === column) {
            if (this.queryContainer.query.reverseSort === true) {
                this.queryContainer.query.reverseSort = false;
            } else {
                this.queryContainer.query.reverseSort = true;
            }
        } else {
            this.queryContainer.query.sortByColumn = column;
            this.queryContainer.query.reverseSort = false;
        }

        const data = {
            sortByColumn: this.queryContainer.query.sortByColumn,
            reverseSort: this.queryContainer.query.reverseSort,
        };
        this._eventBus.emit(
            new EmitEvent("sortColumn", "onColumnSortClick", data)
        );
        $event.preventDefault();
    }

  buildGrid(items) {
      this.companyCodes = items.companyCodes;
      this.workStates = items.workStates;
      this.dayTypes = items.dayTypes;
      this.employeeTypes = items.employeeTypes;
      this.broadcastNetworks = items.networks;
      this.sports = items.sports;
      this.templates = items.data;
      this.templateslength = this.templates.length;
      this.queryContainer = items.queryContainer;
      this.queryContainer.query.sortByColumn = _.isEmpty(
          this.queryContainer.query.sortByColumn
      )
          ? "contactName"
          : this.queryContainer.query.sortByColumn;

      // Iterate templates and format the rate property
      if (Array.isArray(this.templates)) {
          this.templates.forEach((item, idx) => {
              if (item && item.rate !== undefined && item.rate !== null && item.rate !== '') {
                  try {
                      item.rate = this.formatNumber(item.rate);
                  } catch (e) {
                      // Optionally log or handle formatting errors
                  }
              }
          });
      }
  }

    wbseorcc(templateItem, wbsecc) {
        if (wbsecc === "wbse") {
            templateItem.showcc = false;
            templateItem.costCenter = null;
        } else {
            templateItem.showcc = true;
            templateItem.wbse = null;
        }
        this.saveOnChange(templateItem);
    }

    openWBSEModal() {
        const initialState: any = {
            controller: "NbcBudgetCodeComponent",
            hideConfirm: false,
            //reportName: reportName
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };
        this.bsModalRef = this._modalService.show(
            NbcBudgetCodeComponent,
            modalOptions
        );
    }

    selectWBSEModal(templateItem) {
        let modalBudgetCodeRef: BsModalRef;
        //let itemIndex = templateItem.id;
        this.WBSEModal = true;
        const itemIndex = this.getListItemIndex(templateItem.id);
        const initialState: any = {
            self: this,
        };
        const modalOptions = {
            animated: true,
            keyboard: false,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState: initialState,
        };

        modalBudgetCodeRef = this._modalService.show(
            NbcBudgetCodeComponent,
            modalOptions
        );
        modalBudgetCodeRef.content.onSync.subscribe((wbse) => {
            if (wbse && wbse.code) {
                if (itemIndex > -1) {
                    this.templates[itemIndex].wbse = wbse.code;
                    this.templates[itemIndex].wbseDescription =
                        wbse.description;
                    this.templates[itemIndex].companyCode.description =
                        wbse.coCode;
                    this.templates[itemIndex].companyCode.id = wbse.coCode;
                }
            }
            this.saveOnChange(templateItem);
        });
    }

    getListItemIndex(id) {
        return _.findIndex(this.templates, { id: id });
    }

    deleteTemplateDetail(templateDetail) {
        this.disableClearButton = true;

        //soft delete ...
        _.forEach(this.templates, (item) => {
            if (item.id === templateDetail.id) {
                item.isActive = false;
                item.sortOrder = 0;
            }
            if (
                item.id !== templateDetail.id &&
                templateDetail.originalSortOrder !== this.templates.length &&
                item.sortOrder > templateDetail.originalSortOrder
            ) {
                item.sortOrder = item.sortOrder - 1;
            }
        });
        this.upsertTemplateDeatil(this.templates);
    }

    upsertTemplateDeatil(templates) {
        this.log.trace("loading employeetypes");
        this.templateService.upsertTemplateDetail(templates).subscribe({
            next: (result) => {
                this.log.trace("got results:" + JSON.stringify(result));
                //      emit data calling function
                this._eventBusService.emit(
                    new EmitEvent("grid:onDelete", "upsertTemplateDeatil", null)
                );
            },
            error: (err) => {
                this.log.error(err);
                this.log.error(
                    "Unable to load template at this time. Please try again later."
                );
            },
        });
        this.disableClearButton = false;
    }

    saveOnChange(templateDetailRow) {
        if (!_.isArray(templateDetailRow)) {
            templateDetailRow = [templateDetailRow];
        }
        // usSpinnerService.spin("searchSpinner");
        this.templateService.upsertTemplateDetail(templateDetailRow).subscribe({
            next: (result) => {
                this.log.trace("got results: " + JSON.stringify(result));
                if (this.WBSEModal == true) {
                    this.WBSEModal = false;
                    this._eventBusService.emit(
                        new EmitEvent("grid:onChange", "openModel", null)
                    );
                }
            },
            error: (err) => {
                this.log.error(err);
                this.log.showError(
                    "Unable to load template at this time. Please try again later."
                );
            },
        });
    }

    customFormat(index) {
      const listItem = this.templates[index];
      if (listItem.rate) {
        listItem.rate = this.formatNumber(listItem.rate);
      }
    }

    formatNumber(value: number | string): string {
      // Handle empty, null, or undefined input
      if (value === null || value === undefined || value === '') {
        return '';
      }

      // Convert the input to a number
      let numericValue: number;
      if (typeof value === 'string') {
        numericValue = parseFloat(value.replace(/,/g, '')); // Remove commas if present
      } else {
        numericValue = value;
      }

      // Validate if the input is a valid number
      if (isNaN(numericValue)) {
        throw new Error('Invalid input: value is not a valid number.');
      }

      // Format the number with commas and two decimal places
      return numericValue.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }

    employeeTypeValidation(templateDetailRow) {
        templateDetailRow.isWorkStateEnable =
            templateDetailRow.employeeType.id === "FOREIGN" ||
            templateDetailRow.employeeType.id === "LOCORP"
                ? true
                : false;
        templateDetailRow.workState = null;
        this.saveOnChange(templateDetailRow);
    }

    onContactSelected(data) {
        const listId = _.parseInt(data.id);
        const contact = data.contact;
        const itemIndex = this.getListItemIndex(listId);
        if (contact.flaggedByhr) {
            this._eventBusService.emit(
                new EmitEvent(
                    "grid:onContactSelected",
                    "showInvalidContactAlert",
                    null
                )
            );
        } else {
            this.templates[itemIndex].contact = contact;
            this._eventBusService.emit(
                new EmitEvent(
                    "grid:onContactSelected",
                    "assignContact",
                    this.templates[itemIndex]
                )
            );
        }
    }

    onUpdateOnContactSelect(listItem) {
        const modifiedItemAfterSelect = [];
        if (!_.isEmpty(listItem) && listItem.id !== -999) {
            this.saveOnChange(listItem);
        }
    }

    onGlAccount(templateItem) {
        const itemIndex = this.getListItemIndex(parseInt(templateItem.mpId));
        this.templates[itemIndex].glAccount = templateItem.glAccount;
        this.saveOnChange(this.templates);
    }

    subscribeEventHandlers() {
        this.sub.sink = this._sharedDataService
            .getBuAccess()
            .subscribe((access) => (this.buAccess = access));
        this.sub.sink = this._eventBus.on("buildGrid", (result) =>
            this.buildGrid(result)
        );

        this._eventBusService.on("onContactSelected", (data) =>
            this.onContactSelected(data)
        );
        this._eventBusService.on("onUpdateOnContactSelect", (data) =>
            this.onUpdateOnContactSelect(data)
        );
        this._eventBusService.on("onglValueSelected", (data) =>
            this.onGlAccount(data)
        );
    }

    ngOnInit() {
        this.subscribeEventHandlers();
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
